interface CountryType {
  [name: string]: { code: string }
}
export const Country: CountryType = {
  INDIA: {
    code: "IN"
  }
}
